/**
 * Motion preference helper shared by gesture call sites.
 *
 * Centralised so every premium gesture (calendar carousel, row swipe-to-action)
 * honours `prefers-reduced-motion` identically: commit the action instantly,
 * skip the slide/bounce animation.
 */

// oxlint-disable-next-line lingui/no-unlocalized-strings -- CSS media query, not UI copy
const REDUCED_MOTION_QUERY = "(prefers-reduced-motion: reduce)";

export function prefersReducedMotion(): boolean {
  return globalThis.matchMedia?.(REDUCED_MOTION_QUERY).matches ?? false;
}
